import { Pagination } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { INTERBRANCH_MODAL_UPDATE } from '../../../../actions/type';

import { book_appointment, book_Videoconsultaton, Store_formData, update_patient_vital_info } from "../../../../actions/InterBranchCoordinatorAction"

import './consultationhistory.css'
import Spinner from "react-bootstrap/Spinner";

import ConsultationHistorydatePicker from '../../../ConsultationHistorydatePicker/ConsultationHistorydatePicker';

function ConsultationHistory() {

    let dispatch = useDispatch()
    let history = useHistory()
    let reduxData = useSelector(state => state);
    let { path, url } = useRouteMatch();
    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    let appoinmentHistory = reduxData?.interBranchCoordinator?.interBranchPatientDetails?.data?.appointmentHistory;
    let patientId = reduxData?.interBranchCoordinator?.interBranchRegisterPatient?.data?.info;
    let userDetails = JSON.parse(localStorage.getItem("userData"));
    const userId = userDetails.profileId;
    let patientDetails = useSelector(state => state.interBranchCoordinator?.interBranchPatientDetails?.data?.patientDetails);
    let { chosendoctorId, chosenDate, chosenTime, typeOfConsultation, couponCode } = reduxData?.interBranchCoordinator?.appointment_form;


    console.log("appoinmentHistory: ", appoinmentHistory);
   
    let handleTableClick = () => {      

        dispatch({
            type: INTERBRANCH_MODAL_UPDATE,
            payload: { modalName: "patientconsultationHistory", isVisible: true, data: { name: "name" } }
        })


    }

    let isScheduled = () => {

        return url.includes("scheduleappointment")

    }
    let videoconsultation = () => {
        try {
                dispatch(book_Videoconsultaton(patientId, userId, chosendoctorId, typeOfConsultation, couponCode, chosenTime, chosenDate, appointment_form)).
                    then((res) => {
    
                        if (res.data.appointmentId != "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience.") {
                    
                            localStorage.setItem("AppointmentId", res.data.appointmentId)
                            history.push("/joinconsultation/"+res.data.appointmentId);
                        }
                        
                    })
            } catch (error) {
                //console.log("Error in book_appointment API", error);
            }
    }

    return (

        <>
      
        { 
            appoinmentHistory == undefined ? (                
                <div className='loader'
                style={{
                    width:"100%",
                    display:"flex",
                    flexDirection:"row",
                    alignItems:"center",
                    justifyContent:"center",
                    marginTop:"15px",
                    color:"#208ce1"
                }}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>):
            
                appoinmentHistory &&
                appoinmentHistory?.length>0 ? 
                    <table className='appoinment-table'>
                        <thead>
                            <tr>
                                <th>Appointment ID</th>
                                <th>Date/Time</th>
                                <th>Doctor Name</th>
                                <th>Consultation Status</th>
                                {/* <th>Next Steps</th> */}
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>                    
                            {
                                appoinmentHistory != null ?                           
                                    appoinmentHistory.map((element, key) => {
                                        return (
                                            <tr>
                                                <td >{element.prescriptionId}</td>
                                                <td >{element.appointmentDate}</td>
                                                <td >{element.doctorName}</td>
                                                <td >{element.status}</td>
                                                {/* <td >
                                                    Not Available
                                                </td> */}
                                                <td  ><button className='more-btn' onClick={handleTableClick}>More</button></td>

                                            </tr>
                                        )
                                    })
                                    : 
                                    <div>There is no consultation history available for this patient.</div>
                            }
                        </tbody>
                    </table> : <div className="no-appointments">Oops!! There is no consultation history available for this patient.</div>}

                    <div className="pagination-container">
                        {/* <Pagination defaultCurrent={1} total={500} /> */}
                    </div>
                     <div className="button-container" style={{ position:"absolute",bottom:"20px" }}>                       
                        {
                            !isScheduled() &&
                            <button className='join-btn' onClick={videoconsultation}>SKIP AND JOIN CONSULTATION</button>                            
                        }
                     </div>
        </>




    );
}

export default ConsultationHistory;
